import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { HttpUtilService } from './../services/http-util.service';
import { Router } from '@angular/router'
import {  MatTableDataSource, MatSnackBar, MatDialog } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator'
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { ConsultaMaquinaModel } from '../model/consulta-maquina.model'
import Utils from '../utils/utils';
import { tap } from 'rxjs/operators';
import { CertificadoService } from './../services/certificado.service';
import { OutorgaService } from '../services/outorga.service';
import { API_JAVA_CONSULTA_MAQUINA } from './../app.api';

import { HistoricoMaquinaComponent } from './historico-maquina/historico-maquina.component';
import { EditarService } from '../services/editar.service';

@Component({
  selector: 'app-cunsulta-maqina',
  templateUrl: './consulta-maquina.component.html',
  styleUrls: ['./consulta-maquina.component.css']
})
export class ConsultaMaquinaComponent implements OnInit , OnDestroy{
  
  public resposta = '';
  form: FormGroup;
  itemPagina;
  itemMaquina: ConsultaMaquinaModel[] = [];
  dataSource = new MatTableDataSource<ConsultaMaquinaModel>();
  pageSize = 10;
  color = 'primary';
  mode = 'indeterminate';
  value = 50;
  isFetching: boolean;
  paginacao: boolean;
  sub: Subscription;
  subscription: Subscription[] = [];
  SERVICOS_ENVIO = 1;
  funcionalidadesOutorgante;
  inscricaoOutorgante;
  isEmpresaOutorgante;
  parameters = new ConsultaMaquinaModel();
  itensSearched;
  certificado;
  servicos;
  inscricao: string;
  cpfResponsavel;
  tpInscricaoTratada: string;

  displayedColumns: string[] = ['acoes', 'nomeMaquina', 'dtInicial', 'dtExpiracao', 'estadoMaquina'];
  @Input() pageIndex: number;
  @Input() length: number;

  public tipoInscricaoOutorgante: string;

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    public certificadoService: CertificadoService,
    private outorgaService: OutorgaService,
    private router: Router,
    private dialog: MatDialog,
    private edicaoService: EditarService,
    private httpUtilService: HttpUtilService) { this.procuracaoSubscribe() }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  
  ngOnInit() {
    this.createForm();
    this.setLoadingSpinner(true);
    this.obterInscricao();
    this.consultaMaquina();
    this.dataSource.paginator = this.paginator;
    
  }

  obterInscricao() {
    this.certificado = this.certificadoService.obterDadosCertificadoServlet();
    const { tpInscricao, inscricao } = this.httpUtilService.obterDadosCertificado();
    this.tpInscricaoTratada = tpInscricao == "2" ? inscricao.substring(1) : inscricao;
      
    this.inscricao = this.inscricaoOutorgante ? this.inscricaoOutorgante : this.tpInscricaoTratada;
  }

  private setLoadingSpinner(value: boolean) {
    this.isFetching = value;
  }

  createForm() {
    this.form = this.fb.group(
      {
        dtInicial: [null],
        dtFinal: [null],        
        to: new FormControl('', Validators.required),
      },
    );
   
  }

  private procuracaoSubscribe() {
    this.sub = this.outorgaService.getOutorgado()
      .subscribe(response => {
        if (response && response[0]) {
          this.servicos = this.getServicosEnvio(response[1]);
          this.funcionalidadesOutorgante = this.servicos.map(item => item.nu_servico).join(',');
          this.inscricaoOutorgante = response[0].toString().substr(1);
          this.consultaMaquina(null, this.funcionalidadesOutorgante, this.inscricaoOutorgante);
        } else {
          this.removerOutorgante();
          this.processFirstSearch();
        }
      });
  }

  consultaMaquina($event?, funcionalidadesOutorgante?, inscricaoOutorgante?) {

    this.setLoadingSpinner(true);
    this.initParameters();

    if ($event) {
      this.setLoadingSpinner(true);
      this.itemPagina = ($event.pageIndex * $event.pageSize);
      this.itensSearched = $event.pageSize * ($event.pageIndex + 1);
      this.parameters.linhaInicial = (this.itemPagina + 1).toString();
      this.parameters.linhaFinal = (this.itemPagina + $event.pageSize) > $event.length
        ? $event.length.toString() : (this.itemPagina + $event.pageSize).toString();
    } else if (!$event && this.hasFilter()) {
      this.paginacao = false;
      this.itemMaquina = [];
      this.paginator.firstPage();
    }

    this.consultaMaquinaServlet(this.parameters, $event);
  }

  private consultaMaquinaServlet(parameters: ConsultaMaquinaModel, $event: any) {
    const consultaMaquina = this.httpUtilService.post(API_JAVA_CONSULTA_MAQUINA, JSON.stringify(parameters));
    consultaMaquina.subscribe(data => {
      this.itemMaquina.length = this.maisDeDezLinhas(data, parameters) ? Number(data['data']['quantidadeLinhas']) : 0;
      this.converteToObjectConsultaMaquina(data['data']['resultSetConsultaDto'], $event);
      this.dataSource.data = this.itemMaquina;
      this.setLoadingSpinner(false);
    }, err => {
      console.error(err);
    });
  }

  async processFirstSearch() {
    if (!this.funcionalidadesOutorgante && !this.inscricaoOutorgante) {
      await this.consultaMaquina();
    }
  }

  private maisDeDezLinhas(data: any, parameters: ConsultaMaquinaModel) {
    return Number(data['data']['quantidadeLinhas']) > (Number(parameters.linhaFinal) - Number(parameters.linhaInicial) + 1);
  }

  direcionarEdicao(dado: ConsultaMaquinaModel) {
    this.edicaoService.setMaquina(dado);
    this.router.navigate(['/altera-maquina'])
  }

  alterarEstadoMaquina(dado: ConsultaMaquinaModel){
    const data = {
      nomeMaquina: dado.nomeMaquina,
      chaveMaquina: dado.chaveMaquina,
      chaveResponsavelMaquina: dado.inscricaoResponsavel,
      estadoMaquina: dado.estadoMaquina
    };

    this.router.navigate(['/altera-estado-maquina', data], {skipLocationChange: true})
  }

  exibirHistorico(maquina: ConsultaMaquinaModel){
   this.dialog.open(HistoricoMaquinaComponent, {
     data: {maquina},
     width: "800px",
     height: "600px",  
   });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private getServicosEnvio(response) {
    const services = response.filter(item => item.NU_TIPO_FUNCIONALIDADE_CNSN06 === this.SERVICOS_ENVIO);
    return services.map(item => {
      const { NU_SERVICO: nu_servico, DE_FUNCIONALIDADE: de_servico } = item;
      return { nu_servico, de_servico };
    });
  }

  initParameters() {
    this.parameters.dtInicial = this.form !== undefined && this.form.value.dtInicial ? moment(this.form.value.dtInicial).format('YYYY-MM-DD') : '';
    this.parameters.dtFinal = this.form !== undefined && this.form.value.dtFinal ? moment(this.form.value.dtFinal).format('YYYY-MM-DD') : '';
    this.parameters.linhaInicial = this.parameters.linhaInicial ? this.parameters.linhaInicial : '1';
    this.parameters.linhaFinal = this.parameters.linhaFinal ? this.parameters.linhaFinal : '10';
    this.parameters.inscricaoResponsavel = Utils.trataInscricao(this.inscricao);
    }

  private removerOutorgante() {
    this.servicos = null;
    this.funcionalidadesOutorgante = null;
    this.inscricaoOutorgante = null;
  }

  private converteToObjectConsultaMaquina(data: any, $event): ConsultaMaquinaModel[] {
    data.map((item, index) => {
      let itemMaquina = new ConsultaMaquinaModel();
      itemMaquina.chaveMaquina = item.chaveMaquina;
      itemMaquina.inscricaoResponsavel = item.chaveResponsavelMaquina;
      itemMaquina.dtInicial = Utils.convertetoDate(item.dtCadastro);
      itemMaquina.dtFinal = this.retornaTempoCadastroMaquina(Utils.convertetoDate(item.dtExpiracao));
      itemMaquina.icEnvio = item.envioUnico;
      itemMaquina.nomeMaquina = item.nomeMaquina
      itemMaquina.estadoMaquina = item.estadoMaquina

      if ($event) {
        this.itemMaquina.splice((this.itemPagina + index), 1, itemMaquina);
      } else {
        this.itemMaquina.splice(index, 1, itemMaquina);
      }
    });

    return this.itemMaquina;
  }

  retornaTempoCadastroMaquina(dtExpiracao){
    if(dtExpiracao !== null && dtExpiracao === "31/12/9999"){
      return 'Tempo Indeterminado'
    }else if(dtExpiracao === null || dtExpiracao === "31/12/1969"){
      return 'Envio Único';
    }else {
      return dtExpiracao;
    }
  }

  pesquisar($event) {
    this.setLoadingSpinner(true);
    if (this.validacoesFiltro()) {
         this.consultaMaquina($event,  this.funcionalidadesOutorgante, this.inscricaoOutorgante);
    } else {
      this.setLoadingSpinner(false);
    }
  }

 datasValidas(): boolean {
    let retorno = true;
    if (this.form.value.dtInicial && (!this.form.value.dtFinal)) {
      this.form.value.dtFinal;
      this.openSnackBar('Data Final deve ser Preenchida !', 'ERRO'); retorno = false;
    } else if (this.form.value.dtFinal && (!this.form.value.dtInicial)) {
      this.openSnackBar('Data Inicio deve ser Preenchida !', 'ERRO');
      this.form.value.dtInicial; retorno = false;
    } else if (this.form.value.dtInicial > this.form.value.dtFinal) {
      this.openSnackBar('Data Final deve ser maior do que a data Inicial !', 'ERRO');
      this.form.value.dtInicial; retorno = false;
      this.setLoadingSpinner(false);
      return retorno;
    }
    return retorno;
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }

  validacoesFiltro(): boolean {
    let retorno = false;
    if (this.datasValidas()) {
      retorno = true;
    }
    return retorno;
  }

  atualizaFiltro(resposta) {
    this.resposta = (<HTMLInputElement>resposta.target).value;
    if (this.resposta === undefined || this.resposta === '') {
      this.paginacao = false;
    } else {
      this.paginacao = true;
    }
  }

  hasFilter() {
    if(this.form !== undefined){
      if (!this.isEmpty(this.form.value.dtInicial) || !this.isEmpty(this.form.value.dtFinal)) {
        return true;
      } else {
        return false;
      }
      return false
    }
    
  }

  isEmpty(val) {
    return (val === undefined || val == null || val === "" || val.length <= 0) ? true : false;
  }

  

  outorgadoSubscribe() {
    this.subscription.push(this.outorgaService.getOutorgado()
      .pipe(tap(v => v))
      .subscribe(response => {
        if (response && response[2]) {
          this.isEmpresaOutorgante = response[2];
          this.inscricaoOutorgante = response[0].toString().substring(1);
          this.tipoInscricaoOutorgante = response[0].toString().substring(0, 1);
           this.cpfResponsavel = Utils.formatarIncricao(response[2].cpf,'3');
        }
      }));
  }

}


